module.exports = __webpack_public_path__ + "img/logo_talk_inicio.830ca40c.png";